import ProductCards from "./components/products-cards";
import Navigation from "@/js/components/navigation";
import InfoCards from "@/js/components/InfoCards";
import FamilySubscriptions from "@/js/components/family-subscriptions";
import DetailsAccordion from "@/js/components/details-accordion";
import ChatbaseTrigger from "@/js/components/ChatbaseTrigger";

const subscriptionsSelector = '.js-subscriptions';
const exposedFilterSelector = '.views-exposed-form input[name=subscription]';
const subscriptionOptionLabelSelector = '.js-subscription-option-label';
const subscriptionOptionSelector = '.js-subscription-option';

/**
 * @file
 */

(function ($, Drupal) {

    'use strict';

    /**
     * Behavior description.
     */
    Drupal.behaviors.plussmobilTheme = {
      attach: function (context) {

        const checkSubscriptionOption = (subscriptionId) => {
          $('#subscription-option-' + subscriptionId).attr("checked", "checked");
        }

        const selectProduct = ($option, $parent) => {
          $parent.find(exposedFilterSelector).val($option.val()).change();
        }

        const showProduct = ($parent) => {
          $parent.find('.js-subscriptions-full').css('opacity', '1');
        }

        // Execute callback action after Subscriptions View ajax reload.
        const onSubscriptionAjaxReload = (callback) => {
          $(document).ajaxComplete(function (event, xhr, settings) {
              if (settings?.data?.indexOf("view_name=subscriptions_") !== -1) {
                callback();
              }
            }
          );
        }

        function scrollToObject(offset) {
          onSubscriptionAjaxReload(() => {
            window.scrollTo({top: offset.top - 125, behavior: 'smooth'});
          });
        }

        let searchParams = new URLSearchParams(window.location.search)
        const hasSubscriptionParams = searchParams.has('subscription');
        $(subscriptionsSelector).each((index, item) => {
            const $this = $(item);
            const $options = $this.find(subscriptionOptionSelector);

            if (!hasSubscriptionParams) {
              // Selects first subscription if there's no URL filters.
              const $firstOption = $options.first();
              selectProduct($firstOption, $this);
              $firstOption.attr("checked", "checked");
              onSubscriptionAjaxReload(() => {
                showProduct($this);
              });
            } else {
              // Selects subscription from URL filter.
              checkSubscriptionOption(searchParams.get('subscription'));
              if ($this.find(subscriptionOptionSelector).is(":checked")) {
                showProduct($this);
              }
            }
          }
        )

        once('initialized', 'main', context).forEach(function () {
          // Add switch event to the Subscription featured element.
          $('body').on('click', '.subscriptions-full .switch', function (e) {
            e.preventDefault();

            // Hack - Stop Double click on Radio Buttons
            if (e.target.tagName !== 'INPUT') {
              // Toggle checked.
              const $checked = $(this).find('input');
              $checked.attr("checked", !$checked.prop("checked"));
            }
            $(this).closest('.node--type-subscriptions').find('.toggle-visibility').toggleClass('visually-hidden');
          });

          if (searchParams.has('fritale') && searchParams.has('subscription')) {
            const subscription = searchParams.get('subscription')
            const fritale = searchParams.get('fritale');

            if (fritale === "1") {
              $('.subscriptions-full--' + subscription + ' .switch').trigger('click');
            }
          }

          const $window = $(window);
          const root = document.querySelector(':root');
          const ginThemeToolbarHeight = getComputedStyle(root).getPropertyValue('--ginToolbarHeight');
          const ginThemeBreakpoint = 975;
          const mobileThemeBreakpoint = 768;
          const siteHeader = $('#header');

          // Scroll on mobile.
          if (window.innerWidth < mobileThemeBreakpoint && searchParams.has('subscription')) {
            const offsetSubscription = $('.js-subscriptions-view-product .subscriptions-full').offset();
            scrollToObject(offsetSubscription);
          }

          //preload class prevents initial css transitions for all child elements
          $window.on('load', function () {
              $('.js-site').removeClass("preload")
            }
          );

          $window.on('load resize', () => {
            // set sticky header offset if gin admin toolbar is visible
            if (ginThemeToolbarHeight && window.innerWidth > ginThemeBreakpoint) {
              siteHeader.css('top', ginThemeToolbarHeight);
            } else {
              siteHeader.css('top', 0);
            }

            // set css dynamic variables
            const headerHeight = siteHeader.height();
            root.style.setProperty('--header-height', headerHeight + 'px');

            if (mobileThemeBreakpoint && window.innerWidth < mobileThemeBreakpoint) {
              $('body').on('click', '.js-subscriptions-teaser', function () {
                const offset = $('.js-subscriptions-view-product').offset();
                scrollToObject(offset);
              });
            }
          });

          //add important rule to all the colors within gutenberg palette style tag
          const styles = document.querySelector('#gutenberg-palette');
          const colorRegex = /#[0-9a-fA-F]{3,6}/g;
          styles.innerHTML = styles.innerHTML.replace(colorRegex, (match) => `${match} !important`);


          // Components
          new Navigation('.js-menu-toggle').init();
          new ProductCards().init();
          new InfoCards().init();
          new DetailsAccordion().init();
          new ChatbaseTrigger().init();

          // Family subscriptions
          const familySubscriptionsBlocks = document.querySelectorAll('.js-family-subscriptions');
          familySubscriptionsBlocks.forEach((block) => {
            new FamilySubscriptions(block).init();
          });

          // Handle subscription options click.
          $(subscriptionsSelector).each((index, item) => {
            const $this = $(item);
            const $optionLabels = $this.find(subscriptionOptionLabelSelector);

            $optionLabels.on('click', (e) => {
              const $option = $('#' + e.currentTarget.getAttribute('for'));
              selectProduct($option, $this);
            });
          });

        });
      }
    };
  }(jQuery, Drupal)
);
